module.exports = __webpack_public_path__ + "static/media/AIAJ.ad13d72b.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/maxsizeimages/books/AIAJ.jpg
// module id = 1706
// module chunks = 1